import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UpdateLogo.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageUpdateLogoMutationVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
  logoUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
  originalLogoUploadId?: Types.InputMaybe<Types.Scalars['UploadId']['input']>;
}>;


export type EntityPageUpdateLogoMutation = (
  { __typename?: 'Mutation' }
  & { entityPageUpdateLogo?: Types.Maybe<(
    { __typename?: 'EntityPageMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'EntityPagesMutationError' }
      & Pick<Types.EntityPagesMutationError, 'errorType' | 'errorCode'>
    )> }
  )> }
);


export type EntityPageUpdateLogoMutationFn = Apollo.MutationFunction<EntityPageUpdateLogoMutation, EntityPageUpdateLogoMutationVariables>;

/**
 * __useEntityPageUpdateLogoMutation__
 *
 * To run a mutation, you first call `useEntityPageUpdateLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUpdateLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageUpdateLogoMutation, { data, loading, error }] = useEntityPageUpdateLogoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      logoUploadId: // value for 'logoUploadId'
 *      originalLogoUploadId: // value for 'originalLogoUploadId'
 *   },
 * });
 */
export function useEntityPageUpdateLogoMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageUpdateLogoMutation, EntityPageUpdateLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageUpdateLogoMutation, EntityPageUpdateLogoMutationVariables>(Operations.EntityPageUpdateLogo, options);
      }
export type EntityPageUpdateLogoMutationHookResult = ReturnType<typeof useEntityPageUpdateLogoMutation>;
export type EntityPageUpdateLogoMutationResult = Apollo.MutationResult<EntityPageUpdateLogoMutation>;
export type EntityPageUpdateLogoMutationOptions = Apollo.BaseMutationOptions<EntityPageUpdateLogoMutation, EntityPageUpdateLogoMutationVariables>;